import React from 'react'
import StickerGraphic from './StickerGraphic'
import { STICKER_OPTION_BY_ID } from '../../constants/stickerOptions'

// Scale factors used to map editor coordinates/sizes into the print layout.
// These values are empirically tuned to align stickers with the current
// page dimensions defined in the printing layer. If those dimensions change,
// update these factors accordingly.
const PRINT_POSITION_SCALE_X = 1.7
const PRINT_POSITION_SCALE_Y = 1.4
const PRINT_SIZE_SCALE = 1.35

export default function PrintSticker({ sticker }) {
  const option = STICKER_OPTION_BY_ID[sticker.type]
  if (!option) return null

  const position = typeof sticker?.position === 'object' ? sticker.position : { x: 0, y: 0 }
  const size = typeof sticker?.size === 'object' ? sticker.size : { height: 70, width: 70 }
  const rotation = Number.isFinite(sticker?.rotation) ? sticker.rotation : 0
  const printYScale = PRINT_POSITION_SCALE_Y
  // Apply print scale factors (separate X and Y for precise alignment)
  const scaledX = position.x * PRINT_POSITION_SCALE_X
  const scaledY = position.y * printYScale
  const scaledWidth = size.width * PRINT_SIZE_SCALE
  const scaledHeight = size.height * PRINT_SIZE_SCALE

  return (
    <StickerGraphic
      src={option.src}
      alt={option.defaultLabel}
      height={scaledHeight}
      width={scaledWidth}
      x={scaledX}
      y={scaledY}
      rotation={rotation}
      zindex={sticker.zindex}
      data-testid="StickerGraphic"
    />
  )
}
